import { Neo } from "@singularsystems/neo-react";
import React from 'react';
import { Layout } from '@singularsystems/neo-canvas-grid';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import ServiceProviderApiClient from "../../../Maintenance/ApiClients/ServiceProviderApiClient";
import { ClientReportCategories } from "../ClientReportCategories";
import SecurityHoldingsExtractReportCriteria from "./SecurityHoldingsExtractReportCriteria";
import { TextConstants } from "../../../Common/TextConstants";

@NeoReport("SecurityHoldingsExtract", { category: ClientReportCategories.HistoricDataReportExtracts })
export default class SecurityHoldingsExtractReport extends Report<SecurityHoldingsExtractReportCriteria> {
    public serviceProviderApiClient = new ServiceProviderApiClient();

    constructor() {
        super(SecurityHoldingsExtractReportCriteria);
    }

    public renderCriteria() {
        return <>
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingID}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                    />
                </Neo.FormGroup>
                <Neo.FormGroup
                    appendText="fa-calendar"
                    label={TextConstants.Labels.ExportDate}
                    bind={this.criteria.meta.date} 
                />
            </Neo.GridLayout>            
        </>
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}